/** localStorage key for the dismissible Inbox "Get started" block (INBOX-AS-HOME-1). */
export const INBOX_GET_STARTED_DISMISSED_KEY = "zephix-inbox-get-started-dismissed";

export function isInboxGetStartedDismissed(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(INBOX_GET_STARTED_DISMISSED_KEY) === "1";
  } catch {
    return true;
  }
}

export function dismissInboxGetStarted(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(INBOX_GET_STARTED_DISMISSED_KEY, "1");
  } catch {
    // ignore quota / private mode
  }
}
